import template from './daily_balance_sheet_print.html';
import controller from './daily_balance_sheet_print.controller';
import './daily_balance_sheet_print.scss';

let DailyBalanceSheetPrintComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default DailyBalanceSheetPrintComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/daily_balance_sheet/print/daily_balance_sheet_print.component.js